// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2vPW2","select":"Header_select__sEHGS","clinic":"Header_clinic__2YHBZ"};